import React from 'react';
import { Box, Chip, Grid, Typography } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/colors';
import FiberManualRecordSharp from '@material-ui/icons/FiberManualRecordSharp';

export const MapLegend = ({ neighbourhoodCount }) => {
  return (
    <Box
      sx={{
        background: '#fff',
        padding: '5px 10px',
        position: 'absolute',
        top: '40px',
        left: '7px',
        zIndex: 3,
        cursor: 'pointer',
        borderRadius: '4px',
      }}
    >
      <Grid container direction="column">
        <Typography
          sx={{
            fontSize: 13,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Chip
            label={neighbourhoodCount}
            variant={'filled'}
            sx={{
              minWidth: 20,
              borderColor: 'white',
              borderWidth: '1px',
              color: COLOR_PRIMARY_2,
              '&.MuiChip-filled': {
                backgroundColor: 'white',
              },
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
              transform: `scale(0.8)`,
              marginRight: '6px',
            }}
          />{' '}
          Neighbourhood
        </Typography>
        <Typography
          sx={{
            fontSize: 13,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <FiberManualRecordSharp
            style={{
              color: COLOR_PRIMARY_2,
              marginLeft: '10px',
              marginRight: '15px',
              fontSize: 13,
            }}
          />{' '}
          Listing
        </Typography>
      </Grid>
    </Box>
  );
};
